import React from 'react';
import styles from './Monitoring.module.scss';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CountUp from 'react-countup';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import Divider from '@mui/material/Divider';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';

const Monitoring = () => (
  <div className={styles.Monitoring} data-testid="Monitoring">
     <Card sx={{ padding: 0, boxShadow: 0 }} >
                          <CardHeader sx={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 1, }} action={
                              <IconButton aria-label="settings" color='primary' sx={{ marginRight: 1, }} >
                                  {/* <SettingsSuggestIcon /> */}
                              </IconButton>
                          }
                              title="Monitoring & Dispatching" />
                          <Divider />
                          <CardContent sx={{ paddingLeft: 0, paddingRight: 0, }}>


                              <Stack spacing={1} direction="row" useFlexGap flexWrap="wrap">

                                  <Box className="box-tile" sx={{ padding: 2, backgroundColor: 'secondary.main', color: 'secondary.contrastText' }}>
                                      <Typography gutterBottom variant="body2"  >
                                          Unplanned Shipments
                                      </Typography>
                                      <Typography variant="h5" component="h1"   >
                                          <CountUp end={500} duration={1} />
                                      </Typography>
                                  </Box>
                                  <Box className="box-tile" sx={{ padding: 2, backgroundColor: 'secondary.main', color: 'secondary.contrastText' }}>
                                      <Typography gutterBottom variant="body2"  >
                                          Unplanned Movements
                                      </Typography>
                                      <Typography variant="h5" component="h1"  >
                                          <CountUp end={500} duration={1} />
                                      </Typography>
                                  </Box>
                                  <Box className="box-tile" sx={{ padding: 2, backgroundColor: 'secondary.main', color: 'secondary.contrastText' }}>
                                      <Typography gutterBottom variant="body2"  >
                                          Total weight (kg)
                                      </Typography>
                                      <Typography variant="h5" component="h1"   >
                                          <CountUp end={54210} duration={1} />
                                      </Typography>
                                  </Box>
                                  <Box className="box-tile" sx={{ padding: 2, backgroundColor: 'warning.light', color: 'warning.contrastText' }}>
                                      <Typography gutterBottom variant="body2"  >
                                          Total LM
                                      </Typography>
                                      <Typography variant="h5" component="h1"  >
                                          <CountUp end={545} duration={1} />
                                      </Typography>
                                  </Box>

                              </Stack>


                          </CardContent>

                      </Card>
  </div>
);

export default Monitoring;